import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../../components/Converter";
import Dash from "../../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function BezogenerSchlankheitsgrad({ bezogenerSchlankheitsgrad }) {
  const { t } = useTranslation("translation");
  const BezogenerSchlankheitsgradFormula = `\\displaystyle \\overline{\\lambda} = \\frac{L_{cr}}{i \\cdot \\lambda_{1}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.dinEN1993.verification.slenderness")}</p>}
      formulaValue={
        <ToolTip
          id={"BezogenerSchlankheitsgradFormula"}
          type={IconType.FORMULA}
          formula={BezogenerSchlankheitsgradFormula}
        />
      }
      indicesValue={
        <>
          <span style={{ textDecoration: "overline" }}>&lambda;</span>
          {/* <span>
            <sub>k</sub>
          </span> */}
        </>
      }
      inputValue={<span className="input">{ConvertToString(bezogenerSchlankheitsgrad, 2)}</span>}
      unitValue={<Dash />}
    />
  );
}

export default BezogenerSchlankheitsgrad;
